enum GatewayState {
  ACTIVE = "active",
  DISABLED = "disabled",
}

export default GatewayState;
